var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{attrs:{"width":_vm.width,"type":_vm.type,"series":_vm.series,"options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }